import { render, staticRenderFns } from "./ModernFactories.vue?vue&type=template&id=c6acb56e&scoped=true"
import script from "./ModernFactories.vue?vue&type=script&lang=js"
export * from "./ModernFactories.vue?vue&type=script&lang=js"
import style0 from "./ModernFactories.vue?vue&type=style&index=0&id=c6acb56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6acb56e",
  null
  
)

export default component.exports